// components
import { NoData } from '../NoData';
import EntityCalendarRightClickHandler from './components/EntityCalendarRightClickHandler/EntityCalendarRightClickHandler';

// styles
import { Container } from './CalendarContainer.styles';

// stores
import { useCalendarStore } from 'components/mrp/stores/calendarStore/calendarStore';
import { useShallow } from 'zustand/shallow';
import CalendarRow from './components/CalendarRow/CalendarRow';

// calendar handlers
import CalendarNavigationHandler from './components/CalendarNavigationHandler/CalendarNavigationHandler';
import CalendarInteractionHandler from './components/CalendarInteractionHandler/CalendarInteractionHandler';

// const
import { SCROLL_CONTAINER_CLASS } from './CalendarContainer.consts';

// utils
import { getSortedCalendars } from 'components/mrp/mrp.utils';

const CalendarContainer = () => {
  'use memo';
  const calendarIds = useCalendarStore(
    useShallow((state) =>
      getSortedCalendars(state.calendars).map(({ calendarId }) => calendarId)
    )
  );

  return (
    <EntityCalendarRightClickHandler>
      <Container className={SCROLL_CONTAINER_CLASS}>
        {calendarIds.length === 0 && <NoData />}

        {calendarIds.length > 0 && (
          <CalendarNavigationHandler>
            <CalendarInteractionHandler>
              {calendarIds.map((calendarId) => (
                <CalendarRow key={calendarId} calendarId={calendarId} />
              ))}
            </CalendarInteractionHandler>
          </CalendarNavigationHandler>
        )}
      </Container>
    </EntityCalendarRightClickHandler>
  );
};

export default CalendarContainer;
